module.exports = __webpack_public_path__ + "images/shop/favicon-carpardoo/mstile-150x150.png";